import { User } from '@prisma/client';

// No need for a general user role since anyone on the Intel network can
// access the application.  If they are not in Azure AD and have no account
// they will not be able to log in.  Thus we only need to protect controller
// methods with a role guard when they need elevated permissions.
export enum Role {
  ADMIN = 'SAAF.Admin', // must match the name of the role being sent by Azure AD in the token.
  BUNDLE_ADMIN = 'SAAF.BundleAdmin', // must match the name of the role being sent by Azure AD in the token.
  RULE_ADMIN = 'SAAF.RuleAdmin', // must match the name of the role being sent by Azure AD in the token.
  SYSTEM_ADMIN = 'SAAF.SystemAdmin', // must match the name of the role being sent by Azure AD in the token.
  APPLICATION = 'SAAF.Application', // must match the name of the role being sent by Azure AD in the token.
  // DAAS = 'DaaS_SAAF_R_NP', // Data as a Service Saaf Role Non-Prod must match the name of the role being sent by Azure AD in the token.
  NODE_ACCESS_SUPPLIER_LEAD = 'SAAF.NodeAccessSupplierLead',
  NODE_ACCESS_ADMIN = 'SAAF.NodeAccessAdmin',
  NODE_ACCESS_EMS_ACCOUNT_MANAGER = 'SAAF.NodeAccessEMSAccountManager',
  NODE_ACCESS_EXTERNAL_TSMC = 'SAAF.NodeAccessExternalTSMC',
}

export const externalRoles = [Role.NODE_ACCESS_EXTERNAL_TSMC];

export const hasExternalRole = (roles?: Role[]) =>
  !roles?.includes(Role.SYSTEM_ADMIN) && roles?.some((role) => externalRoles.includes(role));

export type UserIdentity = User & { roles: Role[] };
